module.exports = __webpack_public_path__ + "static/media/notification-icon.b5ecc7dc.svg";